export enum ResponseEnum {
  IsSuccess = 'isSuccess',
  Message = 'message',
  Errors = 'errors',
  Data = 'data'
}

export enum StatusEnum {
  Disabled = 'disabled',
  Hidden = 'hidden'
}

export enum Pagination {
  HasNextPage = 'hasNextPage',
  HasPreviousPage = 'hasPreviousPage',
  Items = 'items',
  PageNo = 'pageNo',
  PageSize = 'pageSize',
  TotalCount = 'totalCount',
  TotalPages = 'totalPages'
}

export enum Field {
  ID = 'id',
  UserName = 'userName',
  Password = 'password',
  UserType = 'userType',
  Email = 'email',
  Name = 'name',
  Name2 = 'name2',
  FirstName = 'firstName',
  MiddleName = 'middleName',
  LastName = 'lastName',
  DOB = 'dob',
  Avatar = 'avatar',
  Status = 'status',
  IsActive = 'isActive',
  ValidDurationMonths = 'validDurationMonths',
  Agreements = 'agreement',
  ConsentGiven = 'consentGiven',
  Message = 'message',
  Owner = 'owner',
  OwnerId = 'ownerId',
  AccountType = 'accountType',
  Company = 'company',
  CompanyName = 'companyName',
  CompanyType = 'companyType',
  CompanyEmail = 'companyEmail',
  CompanyShortName = 'companyShortName',
  CompanyTelp = 'companyTel',
  CompanyDetail = 'companyDetail',
  CompanyId = 'companyId',
  LinkOperatorOrContractors = 'linkOperatorOrContractors',
  OperatorOrContractorId = 'operatorOrContractorId',
  OperatorOrContractorImageUrl = 'operatorOrContractorImageUrl',
  Offices = 'offices',
  Contracts = 'contracts',
  Division = 'division',
  ContractName = 'contractName',
  ContractParty = 'contractParty',
  ContractScope = 'contractScope',
  ContractOwner = 'contractOwner',
  ContractEmail = 'contractEmail',
  ContractPhone = 'contractPhone',
  TermCondition = 'termCondition',
  StartDate = 'startDate',
  EndDate = 'endDate',
  UnitValue = 'unitValue',
  MainCurrency = 'mainCurrency',
  SecondCurrency = 'secondCurrency',
  Percentage = 'percentage',
  LocationName = 'locationName',
  LocationType = 'locationType',
  CityId = 'cityId',
  CityName = 'cityName',
  StateId = 'stateId',
  StateName = 'stateName',
  StateCode = 'stateCode',
  Address = 'address',
  Address1 = 'address1',
  Address2 = 'address2',
  PostalCode = 'postalCode',
  SubLocation = 'subLocation',
  DistrictName = 'districtName',
  ContactName = 'contactName',
  ContactTel = 'contactTel',
  ContactEmail = 'contactEmail',
  Timezone = 'timeZone',
  TimezoneDescription = 'timezoneDescription',
  IsHq = 'isHq',
  ServiceOffer = 'serviceOffer',
  ServiceTypes = 'serviceTypes',
  ServiceTypeId = 'serviceTypeId',
  ServiceTypeIds = 'serviceTypeIds',
  ServiceTypeName = 'serviceTypeName',
  ServiceName = 'serviceName',
  TypeOfInterest = 'typeOfInterest',
  ShortName = 'shortName',
  Type = 'type',
  Roles = 'roles',
  Role = 'role',
  Permissions = 'permissions',
  ContactPerson = 'contactPerson',
  CountryCode = 'countryCode',
  CountryId = 'countryId',
  CountryName = 'countryName',
  Cities = 'cities',
  Currency = 'currency',
  PhoneNumber = 'phoneNumber',
  PhoneCode = 'phoneCode',
  RegionId = 'regionId',
  Region = 'region',
  SubRegionId = 'subRegionId',
  SubRegion = 'subRegion',
  SubRegions = 'subRegions',
  SiteId = 'siteId',
  Sites = 'sites',
  SiteName = 'siteName',
  SiteType = 'siteType',
  FieldName = 'fieldName',
  SubsiteId = 'subsiteId',
  Subsites = 'subsites',
  PlatformName = 'platformName',
  PlatformTypeId = 'platformTypeId',
  SubsiteName = 'subsiteName',
  SubsiteType = 'subsiteType',
  BlockName = 'blockName',
  FacilityTypeId = 'facilityTypeId',
  FacilityType = 'facilityType',
  IsCompanyOwner = 'isCompanyOwner',
  TimeZones = 'timeZones',
  Latitude = 'latitude',
  Longitude = 'longitude',
  ZoneName = 'zoneName',
  GmtOffset = 'gmtOffset',
  GmtOffsetName = 'gmtOffsetName',
  Abbreviation = 'abbreviation',
  TzName = 'tzName',
  Token = 'token',
  UserId = 'userId',
  VerificationUri = 'verificationUri',
  Iso = 'iso',
  Code = 'code',
  FlagImagePos = 'flagImagePos',
  Label = 'label',
  Value = 'value',
  ConvertedValue = 'convertedValue',
  Description = 'description',
  DateRange = 'dateRange',
  Layout = 'layout',
  IsApproved = 'isApproved',
  IsConfirmed = 'isConfirmed',
  DataModel = 'dataModel',
  Remark = 'remark',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  TotalWells = 'totalWells',
  TotalSubRegions = 'totalSubRegions',
  UnitMeasurement = 'unitMeasurement',
  Wells = 'wells',
  WellId = 'wellId',
  WellTypeId = 'wellTypeId',
  WellType = 'wellType',
  WellName = 'wellName',
  WellDescription = 'wellDescription',
  WellPurpose = 'wellPurpose',
  WellOriType = 'wellOriType',
  WellStructureType = 'wellStructureType',
  TypeName = 'typeName',
  Reason = 'reason',
  Purpose = 'purpose',
  Geometry = 'geometry',
  WaterDepth = 'waterDepth',
  WaterDepthConversion = 'waterDepthConversion',
  WaterDepthUnit = 'waterDepthUnit',
  Operator = 'operator',
  CompanyLogoFile = 'companyLogoFile',
  CompanyLogoUrl = 'companyLogoUrl',
  ImageUrl = 'imageUrl',
  ImageFile = 'imageFile',
  IconFile = 'iconFile',
  IconUrl = 'iconUrl',
  SlotName = 'slotName',
  Tag = 'tag',
  Uwi = 'uwi',
  UwiType = 'uwiType',
  Formation = 'formation',
  Reservoir = 'reservoir',
  IsOffshore = 'isOffshore',
  IsPlatform = 'isPlatform',
  IsSubsea = 'isSubsea',
  WellborePaginated = 'wellborePaginated',
  Wellbores = 'wellbores',
  WellboreId = 'wellboreId',
  WellboreName = 'wellboreName',
  WellboreNameConcat = 'wellboreNameConcat',
  WellboreNumber = 'wellboreNumber',
  WellboreUwi = 'wellboreUwi',
  WellboreConcatName = 'wellboreConcatName',
  DeepestDepthMd = 'deepestDepthMd',
  DeepestDepthTvd = 'deepestDepthTvd',
  KickOffMd = 'kickOffMd',
  KickOffTvd = 'kickOffTvd',
  WellboreDescription = 'wellboreDescription',
  WellborePurpose = 'wellborePurpose',
  IsMultipleString = 'isMultipleString',
  SpudDate = 'spudDate',
  TagNumber = 'tagNumber',
  MaxAngle = 'maxAngle',
  MaxTemperature = 'maxTemperature',
  MaxTemperatureConversion = 'maxTemperatureConversion',
  MaxTemperatureUnit = 'maxTemperatureUnit',
  Elevation1 = 'elevation1',
  Elevation2 = 'elevation2',
  CompletionDate = 'completionDate',
  WellboreStrings = 'wellboreStrings',
  WellboreStringId = 'wellboreStringId',
  StringIndicator = 'stringIndicator',
  StringName = 'stringName',
  Size = 'size',
  Formations = 'formations',
  FormationName = 'formationName',
  Zones = 'zones',
  TopMd = 'TopMd',
  BottomMd = 'bottomMd',
  TopTvd = 'topTvd',
  BottomTvd = 'bottomTvd',
  OriginalUnit = 'originalUnit',
  TargetUnit = 'targetUnit',
  ConversionFactor = 'conversionFactor',
  ReverseConversionFactor = 'reverseConversionFactor',
  ToolPosition = 'toolPosition',
  GeneralDescription = 'generalDescription',
  ConcatServiceName = 'concatServiceName',
  Index = 'index',
  SortIndex = 'sortIndex',
  IsCompleted = 'isCompleted',
  ProjectId = 'projectId',
  ProjectName = 'projectName',
  ServiceTypePackages = 'serviceTypePackages',
  ServiceAndPackages = 'serviceAndPackages',
  ProjectWellbores = 'projectWellbores',
  ProjectServiceTypePackages = 'projectServiceTypePackages',
  ReportSections = 'reportSections',
  ProjectReportSections = 'projectReportSections',
  PackageId = 'packageId',
  PackageName = 'packageName',
  SectionId = 'sectionId',
  ProjectPlan = 'projectPlan',
  PlanId = 'planId',
  PlanStartDate = 'planStartDate',
  PlanEndDate = 'planEndDate',
  PreparedBy = 'preparedBy',
  ReviewedBy = 'reviewedBy',
  ApprovedBy = 'approvedBy',
  CompletenessPercentage = 'completenessPercentage',
  SectionCompleted = 'sectionCompleted',
  DiagramName = 'diagramName',
  Base64Image = 'base64Image',
  PceDiagramData = 'pceDiagramData',
  ImageHeight = 'imageHeight',
  Offset = 'offset',
  SerialNo = 'serialNo',
  BottomConnection = 'bottomConnection',
  TopConnection = 'topConnection',
  IdIn = 'idIn',
  PressureRating = 'pressureRating',
  Length = 'length',
  Weight = 'weight',
  Service = 'service',
  Objective = 'objective',
  GeneralObjective = 'generalObjective',
  SpecificObjectives = 'specificObjectives',
  SpecificObjectiveId = 'specificObjectiveId',
  Content = 'content',
  JobCategory = 'jobCategory',
  IsStringLevel = 'isStringLevel',
  WellboreLevel = 'wellboreLevel',
  WellboreLevelDetail = 'wellboreLevelDetail',
  StringLevels = 'stringLevels',
  StringLevelDetails = 'stringLevelDetails',
  // SIGN UP
  EmployeeId = 'employeeId',
  JobTitle = 'jobTitle',
  Department = 'department'
}